export default "__VITE_ASSET__C7GRtn$u__"